<template>
  <div class="video-member-container">
    <div class="video-member-container__video">
      <div class="video-content" :class="{ 'active-speaker': member.activity && member.activity.talking }">
        <!-- Publisher -->
        <div
          v-if="member.memberType === VIDEO_MEMBER_TYPES.SELF || member.memberType === VIDEO_MEMBER_TYPES.PUBLISHER"
          ref="self-publisher"
        ></div>

        <!-- Invited user -->
        <div v-else-if="member.memberType === VIDEO_MEMBER_TYPES.INVITEE" class="invite">
          <template v-if="member.invite.inviteStatus === INVITE_STATUSES.SEND">
            <div v-if="canCancelInvite" class="invite-action">
              <button type="button" class="btn btn-default" @click="cancelCallInvite(member.invite)">Cancel</button>
            </div>
            <div v-else class="invite-title">
              Awaiting response...
            </div>
          </template>
          <template v-else-if="member.invite.inviteStatus === INVITE_STATUSES.ACCEPT">
            <div v-if="canResendInvite" class="invite-action">
              <button type="button" class="btn btn-default btn-reconnect" @click="resendCallInvite(member)">
                <i class="fa fa-refresh" aria-hidden="true"></i><br />
                Re-connect
              </button>
            </div>
            <div v-else class="invite-title">
              Connecting...
            </div>
          </template>
        </div>

        <!-- Subscriber -->
        <div v-else-if="member.memberType === VIDEO_MEMBER_TYPES.SUBSCRIBER" ref="subscriber"></div>

        <div v-else>Error</div>
      </div>
    </div>
    <div class="video-member-container__person">
      <div class="name-tag">
        {{ memberUser.profile && memberUser.profile.firstName ? memberUser.profile.firstName : memberUser.firstName }}
      </div>
      <person :person="memberUser" :options="{ actions: true, showIsMe: true, company: true }"></person>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import Person from "@/components/DigitalEvent/RoomList/Room/People/Person";

import { INVITE_STATUSES, VIDEO_MEMBER_TYPES } from "@/helpers/constants";
import VideoCallInviteMixin from "@/components/DigitalEvent/RoomList/Room/mixins/Invite/VideoCallInviteMixin";

export default {
  name: "CallMember",
  components: { Person },
  mixins: [VideoCallInviteMixin], // TODO: Remove mixins in future, use vuex modules
  props: {
    member: Object
  },
  data() {
    return {
      VIDEO_MEMBER_TYPES,
      INVITE_STATUSES
    };
  },
  computed: {
    memberUser() {
      return this.$store.getters["users/getUser"](this.member.userUUID);
    },
    amIVideoCallInitiator() {
      return (
        this.$store.state.videoChat.videoCallInitiator &&
        this.$store.state.videoChat.videoCallInitiator === this.$store.state.users.user.user_uuid
      );
    },
    canCancelInvite() {
      return (
        this.member.invite.inviteStatus === INVITE_STATUSES.SEND &&
        this.$store.state.videoChat.connectionsCount > 1 &&
        this.member.invite.inviterUUID === this.$store.state.users.user.user_uuid
      );
    },
    canResendInvite() {
      return (
        this.member.invite.inviteStatus === INVITE_STATUSES.ACCEPT &&
        this.member.connection &&
        this.amIVideoCallInitiator
      );
    }
  },
  methods: {
    ...mapActions({
      cancelCallInvite: "invites/cancelVideoCallInvite"
    }),
    /** Re-send call invite */
    resendCallInvite(member) {
      this.forceDisconnect(member.connection, async () => {
        let invite = this.$store.getters["invites/sentVideoCallInvites"].find(
          invite => invite.inviteeUUID === member.connection.data
        );
        if (invite) {
          this.$store.commit("invites/deleteSentInvite", invite);
        }
        await this.createVideoCallInvite(member.connection.data, null);
      });
    }
  },
  mounted() {
    if (this.member.memberType === VIDEO_MEMBER_TYPES.SELF || this.member.memberType === VIDEO_MEMBER_TYPES.PUBLISHER) {
      this.$store.dispatch("calls/createDefaultPublisher", { ref: this.$refs["self-publisher"] });
    } else if (this.member.memberType === VIDEO_MEMBER_TYPES.SUBSCRIBER) {
      this.$store.dispatch("calls/createSubscriber", {
        stream: this.member.stream,
        ref: this.$refs["subscriber"]
      });
    }
  }
};
</script>

<style>
.OT_video-poster {
  background-image: url("https://cdn.evessio.com/themes/common/img/profile.png") !important;
  background-position: center;
  background-size: contain;
  opacity: 0.25 !important;
}
</style>
